import request from "@/utils/request";

/**
 * 用户注册
 * @param {Object} data - 注册表单数据
 * @param {string} data.enterpriseName - 企业名称
 * @param {string} data.relationName - 联系人姓名
 * @param {string} data.relationPhone - 联系方式
 * @param {string} data.verCode - 验证码
 * @param {string} data.postName - 职务
 * @param {string} data.wxNumber - 微信号
 * @param {string} data.mail - E-mail
 * @param {string} data.address - 企业地址
 * @param {string} data.password - 密码
 * @param {string} data.role - 角色（purchase / supplier）
 * @param {string} data.headPortrait - 头像URL
 * @param {string} data.businessLicense - 营业执照URL
 */
export function register(data) {
  return request({
    url: "/register",
    method: "post",
    data,
  });
}

/**
 * 获取验证码
 * @param {Object} data
 * @param {string} data.phoneNumber - 手机号
 */
export function getVerCode(data) {
  return request({
    url: "/getVerCode",
    method: "post",
    data,
  });
}
